











































































import { Component, Vue } from 'vue-property-decorator'
import ApiClient from '@/services/api-client'
import { App } from '@/models'
import { Utils } from '@/utils'
import UpsertAppModal from '@/components/modals/UpsertAppModal.vue'

@Component({
  components: { UpsertAppModal }
})
export default class Apps extends Vue {
  private apps: App[] = []
  private loading = false
  private searchFilter = ''
  private selectedApp: App | null = null

  private fields = [
    { key: 'appId', label: this.$t('apps_view.columns.app_id'), sortable: true },
    { key: 'name', label: this.$t('apps_view.columns.name'), sortable: true },
    { key: 'createdOn', label: this.$t('apps_view.columns.created_on'), sortable: true },
    { key: 'actions', label: this.$t('table.actions'), sortable: false, class: 'text-center' }
  ]

  get filteredApps(): App[] {
    if (!this.searchFilter.trim()) return this.apps
    const filterNormalized = Utils.normalizeText(this.searchFilter)
    return this.apps.filter(app => {
      const id = Utils.normalizeText(app.appId)
      const name = Utils.normalizeText(app.name)
      return id.includes(filterNormalized) || name.includes(filterNormalized)
    })
  }

  async created() {
    await this.loadApps()
  }

  async loadApps() {
    try {
      this.loading = true
      this.apps = await ApiClient.getApps()
    } catch (error) {
      console.error('Error loading apps:', error)
      this.$bvToast.toast(this.$t('apps_view.error_loading').toString(), {
        title: this.$t('apps_view.error_title').toString(),
        variant: 'danger',
        solid: true
      })
    } finally {
      this.loading = false
    }
  }

  openCreateModal() {
    this.selectedApp = null
    this.$nextTick(() => this.$bvModal.show('UpsertAppModal'))
  }

  openEditModal(app: App) {
    this.selectedApp = { ...app }
    this.$nextTick(() => this.$bvModal.show('UpsertAppModal'))
  }

  async onAppSaved() {
    await this.loadApps()
    this.$bvToast.toast(this.$t('apps_view.saved_success').toString(), {
      title: this.$t('feedback.feedback_message_success_title').toString(),
      variant: 'success',
      solid: true,
      autoHideDelay: 2000
    })
  }
}
